<template>
  <div class="hello" style="background-color: #fff; min-height: 100vh">
    <div style="padding: 20px 20px">
      <!-- 顶部图片 -->
      <van-image
        width="100%"
        radius="10px"
        :src="require('../assets/picture/jjzb.jpg')"
      />
      <!-- 年份下拉表 -->
      <div>
        <van-row type="flex" justify="end">
          <van-col span="4">
            <select
              v-model="selectYear"
              @change="selectChange($event)"
              class="selectClass"
            >
              <option
                v-for="(item, index) in selectYearsColumns"
                :key="index"
                :value="item"
              >
                {{ item }}
              </option>
            </select>
          </van-col>
        </van-row>
      </div>

      <!-- 按钮题目 -->
      <van-row type="flex" justify="space-between" style="flex-wrap: wrap">
        <van-col
          span="11"
          class="flex-xc-yc"
          :style="
            'background-color:' +
            item.color +
            '; border-radius: 4px; margin-top: 20px; height: 70px; padding: 6px 6px;'
          "
          v-for="(item, index) in itemList"
          :key="index"
          @click="clickMethod(item.activeName)"
        >
          <div
            style="
              font-size: 12px;
              font-weight: 400;
              color: #fff;
              text-align: center;
            "
          >
            {{ item.name }}
          </div>
        </van-col>
      </van-row>
      <!-- 月份 -->
      <div
        class="month"
        v-for="(item, i) in itemList"
        :key="i"
        v-show="
          active == item.activeName &&
          item.monthList != undefined &&
          item.monthList.length != 0
        "
      >
        <div class="flex-xb">
          <div
            class="btn"
            v-for="(mon, j) in item.monthList"
            :key="j"
            :style="'background-color:' + item.color"
            @click="OpenDetail(item.tableConfig, mon.tableData, mon.text, item)"
          >
            {{ mon.month }}
          </div>
          <div class="zhanwei"></div>
          <div class="zhanwei"></div>
        </div>
      </div>
    </div>

    <!-- 表格图表弹窗 -->
    <van-dialog
      v-model="showMrzx"
      :showConfirmButton="false"
      style="width: 95%; height: calc(100% - 90px)"
      class="tanchuang"
    >
      <!-- 最顶部标题 -->
      <div
        style="
          height: 45px;
          padding-top: 10px;
          font-size: large;
          color: cadetblue;
        "
        v-html="dataTitle"
      ></div>
      <div
        :class="
          active == 'zcz' ||
          active == 'xse' ||
          active == 'tze' ||
          active == 'sysr'
            ? 'tableWrap'
            : 'tableNowrap'
        "
        v-if="showMrzx && tableDataActive.length != 0"
      >
        <!-- 表格 -->
        <Table
          :tableConfig="tableConfigActive"
          :tableData="tableDataActive"
        ></Table>

        <!-- 图表 -->
        <div
          v-if="
            active == 'zcz' ||
            active == 'xse' ||
            active == 'tze' ||
            active == 'sysr'
          "
          class="chartsWrap"
        >
          <div id="charts-jjzb-jdzl" class="charts-jjzb"></div>
          <div id="charts-jjzb-jdzs" class="charts-jjzb"></div>
        </div>
      </div>
      <div
        style="height: 20px; color: darkgoldenrod; margin-top: 60px"
        v-if="showMrzx && tableDataActive.length == 0"
      >
        暂无数据
      </div>

      <div
        style="
          position: absolute;
          bottom: 0px;
          width: 100%;
          height: 45px;
          line-height: 45px;
          background-color: #007acc;
        "
        @click="CloseDetail"
      >
        关闭
      </div>
    </van-dialog>

    <div style="height: 100px"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts/core'
import {
  DatasetComponent,
  GridComponent,
  TransformComponent,
} from 'echarts/components'
import { BarChart } from 'echarts/charts'
import { CanvasRenderer } from 'echarts/renderers'

echarts.use([
  DatasetComponent,
  GridComponent,
  TransformComponent,
  BarChart,
  CanvasRenderer,
])

import Table from './custom/Table.vue'
import { deepClone } from '../utils/deepClone'
import { getJjzb } from '@/api/zdqd.js'
import { getDict } from '../api/zdqd.js'
export default {
  name: 'Zdqd',
  components: { Table },
  data() {
    return {
      // 后台获取的年份列表
      selectYearsColumns: [],
      // 获取今年
      selectYear: process.env.VUE_SELECT_YEAR,
      // selectYear: new Date().getFullYear(),
      // 是否显示背景暂无数据
      showMrzx: false,
      // 顶部标题数据
      dataTitle: '',
      // 图标类型
      active: '',
      // 所有的数据
      itemList: [],
      // 传给表格的数据
      tableConfigActive: {},
      // 传给表格的数据
      tableDataActive: [],
    }
  },
  created() {
    // 通过后台配置的字典，拿到年份
    getDict('selectyear_list').then((res) => {
      res.data.content.forEach((x) => {
        this.selectYearsColumns.push(x.label)
      })
    })
    this.getJjzbInfo(this.selectYear)
  },
  methods: {
    selectChange(e) {
      this.getJjzbInfo(e.target.value)
    },
    async getJjzbInfo(selectYear) {
      const res = await getJjzb(selectYear)
      this.itemList = res.data
    },
    clickMethod(id) {
      this.active = id
    },
    async OpenDetail(tableConfig, tableData, text, item) {
      this.dataTitle = item.title
      if (this.active == 'jdp') {
        // 表格的右上标题名字
        tableConfig.columns[3].text = text
      } else if (this.active == 'jjzb') {
        // tableConfig.columns[0].text = tableData.length
        //   ? tableConfig.columns[0].text +
        //     '<br/>GDP (1-' +
        //     (Number(tableData[0].month) - 1) +
        //     '月)'
        //   : tableConfig.columns[0].text
        tableConfig.columns[1].text = text
      } else {
        // 表格的右上标题名字
        tableConfig.columns[1].text = text
      }
      // 传递数据给 table 组件
      this.tableConfigActive = tableConfig
      if (tableData.length > 0) {
        tableData[0].text =
          tableData[0].text + '(1-' + (Number(tableData[0].month) - 1) + '月)'
      }
      this.tableDataActive = tableData
      this.showMrzx = true
      // 图标的数据传递
      if (
        this.active == 'zcz' ||
        this.active == 'xse' ||
        this.active == 'tze' ||
        this.active == 'sysr'
      ) {
        // await this.$nextTick()
        setTimeout(() => {
          this.initCharts(item)
        }, 500)
      }
    },
    CloseDetail() {
      this.showMrzx = false
      this.getJjzbInfo(this.selectYear)
    },

    initCharts(item) {
      var chartDom1 = document.getElementById('charts-jjzb-jdzl')
      if (!chartDom1) {
        return
      }
      var myChart1 = echarts.init(chartDom1)
      var chartDom2 = document.getElementById('charts-jjzb-jdzs')
      var myChart2 = echarts.init(chartDom2)
      let option = {
        title: {
          text: '街道商品销售额总量',
          x: 'center',
          y: '10px',
          subtextStyle: {},
        },
        grid: {
          top: '80px',
          left: '50px',
          right: '20px',
        },
        tooltip: {
          confine: true,
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999',
            },
          },
        },
        xAxis: [
          {
            type: 'category',
            data: this.tableDataActive.map((x) => x.title),
            axisPointer: {
              type: 'shadow',
            },
            axisLabel: {
              interval: 0,
              formatter: function (value) {
                //x轴的文字改为竖版显示
                var str = value.split('')
                return str.join('\n')
              },
              textStyle: {
                fontSize: 10,
                color: '#111',
              },
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '总量(亿元)',
            min: 0,
            max: 2000,
            interval: 200,
            axisLabel: {
              formatter: '{value} ',
            },
          },
        ],
        series: [
          {
            name: '总量',
            type: 'bar',
            barWidth: 15, //固定柱子宽度
            color: '#1492FF',
            tooltip: {
              valueFormatter: function (value) {
                return value + ' '
              },
            },
            data: this.tableDataActive.map((x) => x.blTotal),
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示数值
                  position: 'top', //数值在上方显示
                  textStyle: {
                    //数值样式
                    color: '#000000', //字体颜色
                    fontSize: 10, //字体大小
                  },
                },
              },
            },
          },
        ],
      }

      const jdzlOpt = deepClone(option)
      const jdzsOpt = deepClone(option)

      switch (item.name) {
        case '各街道（功能区）规上工业总产值完成情况表':
          jdzlOpt.title.text = '街道(功能区)规上工业总产值总量'
          jdzsOpt.title.text = '街道(功能区)规上工业总产值增速'
          break
        case '各街道（功能区）限上商品销售额完成情况表':
          jdzlOpt.title.text = '街道(功能区)限上商品销售额总量'
          jdzsOpt.title.text = '街道(功能区)限上商品销售额增速'
          break
        case '各街道（功能区）税源收入':
          jdzlOpt.title.text = '街道(功能区)税源收入总量'
          jdzsOpt.title.text = '街道(功能区)税源收入增速'
          break
        case '各街道（功能区）投资额':
          jdzlOpt.title.text = '街道(功能区)投资额总量'
          jdzsOpt.title.text = '街道(功能区)投资额增速'
          break
        default:
          break
      }

      const tableDataActive0 = deepClone(this.tableDataActive)
      tableDataActive0.sort(function (x, y) {
        return y.blTotal - x.blTotal
      })
      jdzlOpt.xAxis[0].data = tableDataActive0.map((x) => x.title)

      jdzlOpt.series[0].data = tableDataActive0.map((x) => x.blTotal)

      const tableDataActive1 = deepClone(this.tableDataActive)
      tableDataActive1.sort(function (x, y) {
        return y.blRate - x.blRate
      })
      jdzsOpt.xAxis[0].data = tableDataActive1.map((x) => x.title)
      jdzsOpt.series[0].data = tableDataActive1.map((x) => x.blRate)

      jdzlOpt.yAxis[0].name = '总量(亿元)'
      jdzlOpt.yAxis[0].min = item.chartConfig.yAxis.total.min || 0
      jdzlOpt.yAxis[0].max = item.chartConfig.yAxis.total.max || 1000
      jdzlOpt.yAxis[0].interval = item.chartConfig.yAxis.total.interval || 100

      jdzsOpt.yAxis[0].name = '增速(%)'
      jdzsOpt.yAxis[0].min = item.chartConfig.yAxis.rate.min || 0
      jdzsOpt.yAxis[0].max = item.chartConfig.yAxis.rate.max || 1000
      jdzsOpt.yAxis[0].interval = item.chartConfig.yAxis.rate.interval || 100

      jdzlOpt.series[0].name = '总量(亿元)'
      jdzsOpt.series[0].name = '增速(%)'

      myChart1 && myChart1.setOption(jdzlOpt)
      myChart2 && myChart2.setOption(jdzsOpt)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.month {
  padding: 10px;
  margin-top: 40px;
  box-shadow: 0 0 5px #aaa;
  border-radius: 5px;
}
.btn {
  background-color: #aaa;
  width: 22%;
  padding: 10px 0;
  margin: 0 0 10px;
  text-align: center;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  box-sizing: border-box;
  transition: all ease 0.3s;
  opacity: 0.6;
}

.btn:hover {
  transform: translateY(-10%);
  opacity: 1;
}
.zhanwei {
  width: 22%;
}

.tanchuang .tableWrap .conponentTable {
  height: 300px;
  overflow: auto;
  border-bottom: 1px solid #888787;
}
.tanchuang .tableNowrap .conponentTable {
  overflow: auto;
  height: calc(100% - 80px);
}
.tableWrap {
  width: 100%;
  height: calc(100% - 80px);
  position: fixed;
  overflow: scroll;
  padding: 20px;
  box-sizing: border-box;
}
.tableNowrap {
  padding: 20px;
  width: 100%;
  height: 100%;
  position: fixed;
  overflow: scroll;
  box-sizing: border-box;
}
.chartsWrap {
  width: 100%;
  height: 300px;
  transform: translateY(60px);
  animation: myFadeInUp 1s forwards;
}

@keyframes myFadeInUp {
  0% {
    transform: translateY(60px);
  }
  100% {
    transform: translateY(0px);
  }
}
.charts-jjzb {
  width: 100%;
  height: 100%;
}
.selectClass {
  width: 100%;
  border-radius: 4px;
  border: 1px solid #c4c8cf;
  padding: 4px 0px 4px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Jjzb.vue